"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_DURATION_MS = 600000;
exports.DEFAULT_KEY = "cacheUntil";
